module.exports = __webpack_public_path__ + "f2661aa2.svg";